import { Nav } from '@accedo/spatial-nav';
import { FunctionalComponent, Fragment } from 'preact';
import { useMemo } from 'preact/hooks';
import { stylesheet } from 'astroturf';
import clsx from 'clsx';
import { nav } from '##/init';
import { processMarqueeTitle } from '##/utils';
import { MarqueeItem } from './types';

const styles = stylesheet`
  @import '##/styles/import.scss';

  .feature-super-title {
    font-size: 1.8rem;
    font-weight: 200;
    white-space: pre-wrap;
  }

  .feature-title {
    margin-top: pxToVh(10);
    line-height: pxToVh(55);
    font-size: 4.5rem;
    font-weight: 600;
    width: 45%;
    white-space: pre;
    word-break: break-word;
  }

  .title-spacer {
    margin-top: pxToVh(13);
    width: pxToVw(80);
    height: pxToVh(4);
  }

  .feature-description {
    margin-top: pxToVh(13);
    font-size: 1.6rem;
    max-width: 32vw;
    line-height: pxToVh(24);
    height: 9vh;
    font-weight: 300;
    font-family: barlow;
  }

  :global(.button).feature-button {
    display: flex;
    align-items: center;
    min-width: 0;
    padding: pxToVw(10) pxToVw(22) pxToVw(14);
    margin-top: pxToVh(25);
    border-radius: pxToVw(80);
    font-size: 1.65rem;
    border: 1px solid $pure-white;
    font-family: barlowsemicondensed;
    font-weight: 500;

    &:global(.current-focus) {
      border-color: transparent;
    }
  }
`;

export const MarqueeShowInfo: FunctionalComponent<{
  marqueeItem: MarqueeItem;
  watchButtonId: string;
  onSelect: () => void;
}> = ({ marqueeItem, watchButtonId, onSelect }) => {
  const marqueeItemTitle = useMemo(() => {
    if (!marqueeItem?.title) {
      return '';
    }

    return processMarqueeTitle(marqueeItem.title);
  }, [marqueeItem?.title]);

  const { primaryButtonLabel, ctaTitle } = marqueeItem || {};

  return (
    <Fragment>
      <div className={styles.featureSuperTitle}>
        {marqueeItem.superTitle || ' '}
      </div>
      <div className={styles.featureTitle}>{marqueeItemTitle}</div>
      <div
        className={styles.titleSpacer}
        style={{
          backgroundColor: marqueeItem.primaryButtonColor,
        }}
      />
      <div className={styles.featureDescription}>{marqueeItem.description}</div>

      <Nav.Focusable id={watchButtonId} onSelect={onSelect}>
        <button
          id={watchButtonId}
          className={clsx('button', styles.featureButton)}
          style={{
            backgroundColor:
              nav.currentFocusNode?.id === watchButtonId
                ? marqueeItem.primaryButtonColor
                : 'transparent',
          }}
        >
          {ctaTitle || primaryButtonLabel}
        </button>
      </Nav.Focusable>
    </Fragment>
  );
};
